var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useDispatch } from "react-redux";
import { useState } from "react";
import { resetPasswordAction } from "../../../reduxStore/actions/salesRepDataAction";
import { useTranslation } from "react-i18next";
import { checkEmailValidation } from "../../CustomerInvoice/Validation";
export function ForgotPasswordBL() {
    var _this = this;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var _a = useState(false), isLoadingFlag = _a[0], setLoadingFlag = _a[1];
    var _b = useState(""), emailField = _b[0], setEmailField = _b[1];
    var _c = useState({ emailErrMsg: "" }), errorMessage = _c[0], setErrorMessage = _c[1];
    var resetBtnEnabled = (emailField === null || emailField === void 0 ? void 0 : emailField.length) > 0 && errorMessage.emailErrMsg === "";
    var _d = useState(""), resetPasswordErrMsg = _d[0], setResetPasswordErrMsg = _d[1];
    var _e = useState(false), emailValidFlag = _e[0], setEmailValidFlag = _e[1];
    var handleKeyDown = function (event) {
        if (event.key === "Enter" && event.keyCode === 13 && resetBtnEnabled) {
            resetPassword();
        }
    };
    var resetPassword = function () { return __awaiter(_this, void 0, void 0, function () {
        var resetPasswordResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoadingFlag(true);
                    return [4 /*yield*/, dispatch(resetPasswordAction(emailField))];
                case 1:
                    resetPasswordResponse = _a.sent();
                    if (resetPasswordResponse.status == 200) {
                        setEmailValidFlag(true);
                        setLoadingFlag(false);
                        setEmailField("");
                    }
                    else if (resetPasswordResponse.status == 500) {
                        setEmailValidFlag(false);
                        setLoadingFlag(false);
                        setResetPasswordErrMsg(resetPasswordResponse.message);
                    }
                    else {
                        setEmailValidFlag(false);
                        setLoadingFlag(false);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleEmailChange = function (e) {
        var value = e.target.value;
        fieldsValidation(value);
        setEmailField(value);
        setResetPasswordErrMsg("");
    };
    var fieldsValidation = function (value) {
        value === ""
            ? setErrorMessage(function (values) { return (__assign(__assign({}, values), { emailErrMsg: t("required_ErrorMsg") })); })
            : checkEmailValidation(value.trim())
                ? setErrorMessage(function (values) { return (__assign(__assign({}, values), { emailErrMsg: t("emailValidation_ErrorMsg") })); })
                : setErrorMessage(function (values) { return (__assign(__assign({}, values), { emailErrMsg: "" })); });
    };
    return { t: t, errorMessage: errorMessage, isLoadingFlag: isLoadingFlag, resetPasswordErrMsg: resetPasswordErrMsg, resetBtnEnabled: resetBtnEnabled, emailField: emailField, emailValidFlag: emailValidFlag, handleEmailChange: handleEmailChange, resetPassword: resetPassword, handleKeyDown: handleKeyDown };
}
